import apiClient from "./api";
const REEMBOLSO_API_BASE_URL = "/reembolsos";
class ReembolsoService {
  getReembolsos() {
    return apiClient.get(REEMBOLSO_API_BASE_URL);
  }

  getReembolsoActual(sucursalId) {
    return apiClient.get(`${REEMBOLSO_API_BASE_URL}/actual/${sucursalId}`);
  }

  async getReembolsoPorCorte(idSucursal, idCorte) {
    try {
      const response = await apiClient.get(
        `${REEMBOLSO_API_BASE_URL}/corte/${idSucursal}/${idCorte}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

}
export default new ReembolsoService();
